/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../api/core/glass/GlassDashboardBuilder'
], function(GlassDashboardBuilder) {
	/**
	*  Dashboard service that can be used to provide a dashboard runtime environment
	*  that is needed to run code that is dashboard dependant (e.g. live widget) but without a dashboard Perspective
	*  The service will require the dashboard perspective json, and use it to provide all the needed extensions and collections
	*/
	class DashboardRuntimeService {

		constructor() {}

		initialize(glassContext) {
			this._glassContext = glassContext;
			const perspectiveLoader = glassContext.getCoreSvc('.Perspective');
			return perspectiveLoader.getModel('dashboard').then((model) => {
				this._dashboardPerspective = model;
			});
		}

		getDefaultSpec() {
			return {
				'name': 'New dashboard',
				'layout': {
					'id': 'page0',
					'items': [],
					'style': {},
					'type': 'tab'
				},
				'theme': 'carbonGrey10',
				'eventGroups': [],
				'fredIsRed': {
					'colorMap': {},
					'saveId': 2
				},
				'pageContext': [],
				'dataSources': {
					'version': '1.0',
					'sources': []
				},
				'widgets': {}
			};
		}

		getRuntimeEnvironment(options) {
			if (!options && this.defaultRuntimeEnv){
				return Promise.resolve(this.defaultRuntimeEnv);
			}
			const dashboardBuilder = GlassDashboardBuilder.create({
				glassContext: this._glassContext,
				perspectiveModel: this._dashboardPerspective,
				featuresOverride: options && options.featuresOverride,
				apiConsumerConfig: options && options.apiConsumerConfig
			});
			return dashboardBuilder.initializeRuntime(options).then((runtimeEnv) => {
				return runtimeEnv.getRuntimeEnvironment(options, this.getDefaultSpec.bind(this))
					.then( env => {
						if (!options){
							this.defaultRuntimeEnv = env;
						}
						return env;
					});
			});
		}
	}
	return DashboardRuntimeService;
});
